import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';

import { App } from './App.jsx';
import { AdminAuthProvider } from './auth/AdminAuthContext.jsx';
import { UIProvider } from './ui/UIProvider.jsx';
import './styles/global.css';

// Self-hosted Twemoji woff2 lives in public/ → served at the root.
// We don't import it through the npm package's deep path because
// the package's `exports` field gates that. Copying to public/
// also means Vite preserves the exact filename in the build, so
// browser caches are stable across deploys.
//
// Browsers that already render flag emoji natively (macOS, iOS,
// Android, Linux) never download this — the polyfill's canvas
// detection skips the @font-face injection entirely. Windows
// Chromium gets the ~78 KB font once, cached for the session.
polyfillCountryFlagEmojis('Twemoji Country Flags', '/TwemojiCountryFlags.woff2');

/**
 * Root mount. Provider order matters:
 *
 *   BrowserRouter   — `useLocation` / `useNavigate` work everywhere below.
 *   UIProvider      — toast + confirm need to be available to anything,
 *                      including pre-auth screens like Login.
 *   AdminAuthProvider — depends on UIProvider only because login flow
 *                       surfaces errors via toast.
 *   App             — does its own routing inside.
 */
createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <UIProvider>
        <AdminAuthProvider>
          <App />
        </AdminAuthProvider>
      </UIProvider>
    </BrowserRouter>
  </React.StrictMode>
);
